import { ApiError, ErrorResponseDto } from '@pro4-erp/core-web';
import env from '@/env';
import { AuditProposalDetail } from '../types';

export const getAuditorProposalById = async (id: string): Promise<AuditProposalDetail> => {
  const fetchResponse = await fetch(
    `${env.VITE_API_URL}/pb/s/api/sqo-portal/audit-proposals/${id}`,
    {
      method: 'GET',
      headers: {
        authenticate: localStorage.getItem('accessToken') || '',
      },
    }
  );

  if (!fetchResponse.ok) {
    const error = (await fetchResponse.json()) as ErrorResponseDto;
    throw new ApiError(error);
  }

  const response = (await fetchResponse.json()) as AuditProposalDetail;
  return response;
};
